import { render, staticRenderFns } from "./Illness.vue?vue&type=template&id=4ec41262&"
import script from "./Illness.vue?vue&type=script&lang=js&"
export * from "./Illness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports